import {
  Classes,
  Tooltip,
  TooltipProps as BlueprintTooltipProps,
} from "@blueprintjs/core";

export interface TooltipProps extends BlueprintTooltipProps {
  shouldShowTooltip: boolean;
}

export const RelativityTooltip: React.FC<TooltipProps> = ({
  shouldShowTooltip,
  content,
  children,
  ...otherProps
}) => {
  return (
    <Tooltip
      {...otherProps}
      content={<div className="ucl-tooltip-content">{content}</div>}
      popoverClassName={Classes.POPOVER_CONTENT_SIZING}
      portalClassName={"tooltip-popover"}
      disabled={!shouldShowTooltip}
    >
      {children}
    </Tooltip>
  );
};
